import { from, of } from "rxjs"
import { ofType } from "redux-observable"
import { switchMap, catchError } from "rxjs/operators"
import { push } from "connected-react-router"

import {
    fetchChargeDetailsSuccess,
    fetchChargeSummariesSuccess,
} from "./actions"
import * as errorActions from "../error/actions"

import { hideLoader } from "../loader/actions"

import chargeManagementApi from "../../api/chargeManagement-api"
import * as types from "./actionTypes"

export function fetchDemurrageSummaries(action$) {
    return action$.pipe(
        ofType(types.CHARGE_SUMMARIES_FETCH),
        switchMap((action) =>
            from(
                chargeManagementApi.getDemurrageSummaries(action.payload)
            ).pipe(
                switchMap((data) =>
                    of(fetchChargeSummariesSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
export function fetchDemurrageDetails(action$) {
    return action$.pipe(
        ofType(types.CHARGE_SUMMARIES_DETAILS_FETCH),
        switchMap((action) =>
            from(chargeManagementApi.getDemurrageDetails(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchChargeDetailsSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
